// extracted by mini-css-extract-plugin
export default {"header":"BillingPaymentSchedule_header__vi9BT","title":"BillingPaymentSchedule_title__F6Tsf"};